import React from 'react';
import { Box, Chip, Tooltip, Typography, Button } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';
import { calculateDistance, formatDistance } from '../../utils/stopUtil';
import { subLineMap } from '../../enum/serviceType';
import { useAppState } from '../../context/AppStateProvider';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';


function StopPopup({ stop, userLocation, routeIds = [], showMore = false }) {
  const stopLat = parseFloat(stop.stop_lat);
  const stopLon = parseFloat(stop.stop_lon);
  const { setSelectedStop } = useAppState();

  const distance = userLocation
    ? calculateDistance(stopLat, stopLon, userLocation.lat, userLocation.lng)
    : null;

  const allLines = Object.values(subLineMap).flat();

  const getRouteInfo = (routeId) =>
    allLines.find(line => line.code === routeId || line.line === routeId);

  const title = [
    stop.category?.toUpperCase() || '',
    stop.stop_name || 'Unnamed Stop',
  ]
    .filter(Boolean)
    .join(' ');

  const onMoreClick = (stop) => {
    setSelectedStop(stop);
  };

  return (
    <Box sx={{ minWidth: 150, p: 1 }}>
      <Typography variant="h6" color="primary">
        {title}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <RoomIcon
          fontSize="small"
          sx={{ color: distance < 1 ? 'warning.main' : 'info.main' }}
        />
        <Typography variant="body2" fontWeight="bold">
          {formatDistance(distance)} away
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {routeIds.map((id) => {
          const info = getRouteInfo(id);
          const chipColor = info?.color || '#1976d2';

          return (
            <Tooltip key={id} title={info?.name}>
              <Chip
                label={info?.name}
                size="small"
                sx={{
                  backgroundColor: chipColor,
                  color: '#fff',
                  fontWeight: 500,
                }}
              />
            </Tooltip>
          );
        })}
      </Box>

      {/* More button */}
      {showMore ?
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="text"
            size="small"
            onClick={() => onMoreClick?.(stop)}
            sx={{ textTransform: 'none' }}
          >
            More →
          </Button>
        </Box>
        :
        null}

      {userLocation && (
        <Box display="flex" justifyContent="flex-end" mt={1}>
          <Button
            variant="text"
            size="small"
            onClick={() =>
              window.open(
                `https://www.google.com/maps/dir/?api=1&origin=${userLocation.lat},${userLocation.lng}&destination=${stopLat},${stopLon}&travelmode=walking`,
                '_blank'
              )
            }
            startIcon={<DirectionsWalkIcon />}
            sx={{ textTransform: 'none' }}
          >
            Get Directions
          </Button>

        </Box>
      )}


    </Box>
  );
}

export default StopPopup;
